export default __webpack_public_path__ + "resources/icons/n100-23ae.webp";